export interface BillTimeInfo {
  startTime?: {
    seconds?: number | null
  } | null
  endTime?: {
    seconds?: number | null
  } | null
}

export interface BillDurationSource {
  timeInfo?: BillTimeInfo | null
  Info?: {
    BillingInfo?: {
      usedTimeSec?: number | null
    } | null
    HwItemBillInfo?: {
      availableSecs?: number | null
    } | null
  } | null
}

/**
 * Calculates the duration covered by an aggregated instance bill.
 *
 * PAYG bills use the backend's current time as endTime, while subscription
 * bills use the subscription expiration time. Missing or zero-valued endTime
 * falls back to the current time so a running bill can still show a duration.
 * Per-segment usedTimeSec and availableSecs values are intentionally ignored.
 */
export function getBillDurationSec(
  bill?: BillDurationSource | null,
  nowSeconds = Math.floor(Date.now() / 1000),
): number | undefined {
  const timeInfo = bill?.timeInfo
  const startSeconds = timeInfo?.startTime?.seconds
  if (typeof startSeconds !== 'number' || !Number.isFinite(startSeconds)) return undefined

  const providedEndSeconds = timeInfo?.endTime?.seconds
  let endSeconds: number

  if (providedEndSeconds === undefined || providedEndSeconds === null || providedEndSeconds === 0) {
    if (!Number.isFinite(nowSeconds)) return undefined
    endSeconds = nowSeconds
  } else {
    if (!Number.isFinite(providedEndSeconds)) return undefined
    endSeconds = providedEndSeconds
  }

  if (endSeconds < startSeconds) return undefined
  return endSeconds - startSeconds
}
